import { ErrorMessages } from '@/constants/errorMessages';
import { getEmailError, getOptionalPhoneError, getRequiredError } from '@/lib/validators';

export const ContactFieldIds = {
  name: 'contact-name',
  email: 'contact-email',
  company: 'contact-company',
  phone: 'contact-phone',
  message: 'contact-message',
};

export const ContactFieldOrder = Object.keys(ContactFieldIds);

export const EmptyContactMessage = {
  name: '',
  email: '',
  company: '',
  phone: '',
  message: '',
};

export function validateContactMessage(values) {
  return {
    name: getRequiredError(values.name, ErrorMessages.name.required),
    email: getEmailError(values.email),
    company: null,
    phone: getOptionalPhoneError(values.phone),
    message: getRequiredError(values.message, ErrorMessages.message.required),
  };
}